import React, { createContext, useContext, useState, useEffect } from 'react';
import API from '../api/axios';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('admin_access_token');
    if (token) {
      API.get('/auth/profile/').then(r => {
        if (r.data.role === 'admin') setAdmin(r.data);
        else { localStorage.removeItem('admin_access_token'); }
      }).catch(() => localStorage.removeItem('admin_access_token'))
        .finally(() => setLoading(false));
    } else setLoading(false);
  }, []);

  const login = async (username, password) => {
    const { data } = await API.post('/auth/login/', { username, password });
    if (data.user.role !== 'admin') throw new Error('Not an admin account');
    localStorage.setItem('admin_access_token', data.access);
    setAdmin(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem('admin_access_token');
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
